import { PrimaryButton } from 'components/Button/src/jsx/Button';
import PropTypes from 'prop-types';
import { useScene } from '../hooks/useScene';
import Heading from './Heading';

export default function Error({ data, getLabel, message, reload, setSceneData }) {
	useScene('error', { data, setSceneData });

	return (
		<div className="trial__error">
			<Heading title={getLabel('error_heading')} subtitle={message} />
			<img className="error__image" src={data.visuals.error.full_url} alt={data.visuals.error.alt} />
			<div className="error__message" dangerouslySetInnerHTML={{ __html: getLabel('error_content') }} />
			<PrimaryButton onClick={reload} testId="nav-restart">
				{getLabel('nav_btn_reset')}
			</PrimaryButton>
		</div>
	);
}

Error.propTypes = {
	data: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	message: PropTypes.string.isRequired,
	reload: PropTypes.func.isRequired,
	setSceneData: PropTypes.func.isRequired,
};
